(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warriors-home"] && !Shopify.designMode) return;
  try {
    
function initializeWarriorsFilters(root) {
  root.querySelectorAll('.ww-preview').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const filters = section.querySelector('.ww-filters');
    const cards = Array.from(section.querySelectorAll('.ww-preview-card'));
    const more = section.querySelector('.ww-more-button');
    const status = section.querySelector('.ww-filter-status');
    let selected = 'all';
    let expanded = false;
    const update = () => {
      const matches = cards.filter(card => selected === 'all' || card.dataset.audience === selected || card.dataset.audience === 'both');
      cards.forEach(card => { card.hidden = !matches.includes(card) || (!expanded && matches.indexOf(card) >= 8); });
      more.hidden = expanded || matches.length <= 8;
      status.textContent = `${expanded ? matches.length : Math.min(8, matches.length)} / ${matches.length}`;
      filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === selected)));
    };
    filters.hidden = false;
    status.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('button[data-filter]');
      if (!button) return;
      selected = button.dataset.filter;
      expanded = false;
      update();
    });
    more.addEventListener('click', () => {
      expanded = true;
      update();
      const visible = cards.filter(card => !card.hidden);
      if (visible[8]) { visible[8].tabIndex = -1; visible[8].focus({preventScroll:true}); }
    });
    update();
  });
}
document.querySelectorAll('.ww-preview-image[aria-pressed]').forEach(button => {
  button.addEventListener('click', () => button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true')));
});
initializeWarriorsFilters(document);
document.addEventListener('shopify:section:load', event => initializeWarriorsFilters(event.target));
function initializeWarriorsVideos(root) {
  root.querySelectorAll('.ww-video-toggle').forEach(button => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    const video = button.parentElement.querySelector('video');
    const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; button.setAttribute('aria-label', button.textContent); };
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
    button.addEventListener('click', () => { if (video.paused) video.play().catch(update); else video.pause(); });
    update();
  });
}
initializeWarriorsVideos(document);
document.addEventListener('shopify:section:load', event => initializeWarriorsVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
